<template>
    <fieldset
        v-if="type === 'section' || type === 'fieldset'"
        :class="`${classFieldset} ${!noMarginTop ? 'mt-2' : ''}`"
    >
        <legend v-if="title.length > 0 || showLegend">
            <div>
                <template v-if="$scopedSlots.leading">
                    <span class="pr-2"><slot name="leading" /></span>
                </template>

                <strong>{{ title }}</strong>

                <template v-if="$scopedSlots.trailing">
                    <span class="pl-2"><slot name="trailing" /></span>
                </template>
            </div>

            <div v-if="subtitle">
                <small>{{ subtitle }}</small>
            </div>
        </legend>

        <slot />
    </fieldset>

    <div
        v-else-if="type === 'box'"
        :class="{'mt-2' : !noMarginTop}"
    >
        <rkm-card
            :border-color="backgroundColor ? null : 'primary'"
            no-body
        >
            <rkm-card-header
                :background-color="backgroundColor"
                :header-class="headerClass"
                border-color="primary"
                class="p-0"
                v-rkm-toggle:[id]
            >
                <div class="d-flex align-items-stretch header-prefix-content">
                    <div class="d-flex mr-auto">
                        <div class="d-flex">
                            <div
                                v-if="!!headerPrefixIcon || !!headerPrefixText"
                                :style="headerPrefixStyle"
                                class="d-flex px-3 header-prefix"
                            >
                                <rkm-icon
                                    v-if="!!headerPrefixIcon"
                                    :icon="headerPrefixIcon"
                                    class="m-auto"
                                />

                                <strong
                                    v-else
                                    class="m-auto header-prefix-text"
                                >
                                    {{ headerPrefixText }}
                                </strong>
                            </div>

                            <div
                                :class="`text-${backgroundColor || 'primary'}`"
                                class="my-auto ml-2 header-title"
                            >
                                <strong>{{ title }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="my-auto mr-2">
                        <rkm-icon :icon="`chevron-${opened ? 'up' : 'down'}`" />
                    </div>
                </div>
            </rkm-card-header>

            <rkm-collapse
                :id="id"
                :visible="!closed"
                @hide="opened = false"
                @show="opened = true"
                acordion="area-acordion"
            >
                <rkm-card-body>
                    <slot />
                </rkm-card-body>
            </rkm-collapse>
        </rkm-card>
    </div>
</template>

<script>
export default {
    computed: {
        classFieldset() {
            return `rkm-area ${this.type} variant-${this.color} heading-${this.titleHeading}`
        },
        headerPrefixStyle() {
            return {
                '--header-background-color': `var(--${this.backgroundColor})`,
                '--header-prefix-color': this.headerPrefixColor,
            }
        },
        id() {
            return this.uniqueId('area-acordion')
        },
    },
    created() {
        this.opened = !this.closed
    },
    data: () => ({
        opened: false,
    }),
    props: {
        backgroundColor: { type: String },
        closed: { type: Boolean },
        color: { type: String, default: 'primary' },
        headerClass: { type: String },
        headerPrefixColor: { type: String, default: 'white' },
        headerPrefixIcon: { type: String },
        headerPrefixText: { type: String },
        noMarginTop: { type: Boolean, default: false },
        showLegend: { type: Boolean },
        subtitle: { type: String },
        title: { type: String, default: '' },
        titleColor: { type: String, default: 'primary' },
        type: { type: String, default: 'section' },
    },
}
</script>

<style lang="scss" scoped>
fieldset > *:last-child .form-group {
    margin-bottom: 0;
}
fieldset {
    padding: 0.5rem 0 0 0;
}
legend {
    color: #555;
    font-size: 1.05em;
    line-height: 20px;
    margin: 0;
    text-transform: uppercase;
    width: auto;
}
.rkm-area button {
    margin: -13px 0 -7px 0;
    vertical-align: middle;
}
.rkm-area .dropdown {
    margin: -13px 0 -7px 0;
    vertical-align: middle;
}
.fieldset {
    border-radius: 3px;
    border: 1px solid #555;
    margin: 7px 0;
    padding: 15px;
}
.fieldset legend {
    padding: 0 1rem;
}
.section legend {
    border-bottom: 2px solid #555;
    font-size: 1.05em;
    padding: 10px 0;
    text-transform: uppercase;
    width: 100%;
}
.section.heading-2 > legend span,
.section.heading-3 > legend span {
    font-weight: 400;
}
.section.heading-3 > legend > .subtitle {
    font-size: 16px;
}
.section.heading-2 > legend {
    border-bottom-width: 1px;
}
.section.heading-3 > legend {
    border-bottom: none;
}
.variant-primary legend {
    color: #007bff;
}
.variant-primary.fieldset {
    border-color: #007bff;
}
.variant-primary.section legend {
    border-bottom-color: #007bff;
}
.variant-gestante legend {
    color: var(--gestante-primary);
}
.variant-gestante .fieldset {
    border-color: var(--gestante-primary);
}
.variant-gestante.section legend {
    border-color: var(--gestante-primary);
}
.header-prefix-content {
    height: 40px !important;
}
.header-prefix {
    background-color: var(--header-background-color);
    border-radius: 3px 0 0 0;
    color: var(--header-prefix-color);
    min-width: 52px;
}
.header-prefix-text {
    font-size: 22px;
}
.header-title {
    font-size: 1.05em;
    text-transform: uppercase;
}
</style>